
/*
 * @Author: panweikang
 * @Date: 2024-01-04 15:23:35
 * @LastEditTime: 2024-07-25 16:59:25
 * @Description:
 */
import './GroupBuying.scss'
import React, { useEffect, useState } from 'react'
import logo from '../../static/report/logo.png'
import tiefenActivePng from '../../static/pay/tiefen_active.png'
import tiefenPng from '../../static/pay/tiefen.png'
import lightPng from '../../static/pay/light.png'
import boughtPng from '../../static/pay/bought.png'
import tipsPng from '../../static/pay/tips.png'

import ptPng from '../../static/YearMiddleReport2024/GroupBuying/pt.png'
import jjPng from '../../static/YearMiddleReport2024/GroupBuying/jj.png'
import jjBlackPng from '../../static/YearMiddleReport2024/GroupBuying/jj_black.png'
import sqPng from '../../static/YearMiddleReport2024/GroupBuying/sq.png'

import { Avatar, Image, Button, Toast } from 'antd-mobile'
import { MailOutline } from 'antd-mobile-icons'

// import { regionImage, regionDes } from './constants'
import {
  getSharePayDetailApi,
  getRegionListApi,
  wxJsapiPayApi,
  jsConfigApi,
  getBarrageMessageApi,
  updateUserEmailApi,
  getTeamWorkInfoApi,
  getUserInfoApi,
} from '../../api/yearEndReportApi'

import clonedeep from 'lodash.clonedeep'
import Decimal from 'decimal.js'
import { useMemo } from 'react'

import { useNavigate, useSearchParams } from 'react-router-dom'
import wxConfig from '../../utils/wxConfig'
import EMailModal from '../../components/MEmail/index'

// import MShare from '../../components/MShare/index'
import MHead from '../../components/MHead/index'
import Barrage from './Barrage'
import { yearMiddle2024 } from './constants'
import { useImmer } from 'use-immer'
import { countdown } from '../../utils/utils'
import qs from 'qs'


// step
let MStepper = ({ disable, onChange }) => {
  let [count, setCount] = useState(0)

  useEffect(() => {
    onChange(count)
  }, [count])

  let minus = () => {
    if (disable || count === 0) {
      return
    }
    setCount(count - 1)
  }
  let add = () => {
    if (disable || count === 1) {
      return
    }
    setCount(count + 1)
  }

  return (
    <div className="MStepper">
      <svg
        onClick={minus}
        t="1704436791771"
        className="icon-minus"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="5514"
        width="18"
        height="18"
      >
        <path
          d="M533.333333 85.333333c-247.426667 0-448 200.573333-448 448s200.573333 448 448 448 448-200.573333 448-448-200.573333-448-448-448z m0 853.333334c-223.86 0-405.333333-181.473333-405.333333-405.333334s181.473333-405.333333 405.333333-405.333333 405.333333 181.473333 405.333334 405.333333-181.473333 405.333333-405.333334 405.333334z m234.666667-405.333334a21.333333 21.333333 0 0 1-21.333333 21.333334H320a21.333333 21.333333 0 0 1 0-42.666667h426.666667a21.333333 21.333333 0 0 1 21.333333 21.333333z"
          fill="#5C5C66"
          p-id="5515"
        ></path>
      </svg>
      <p>{count}</p>
      <svg
        onClick={add}
        t="1704436595792"
        className="icon-add"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="4542"
        width="18"
        height="18"
      >
        <path
          d="M511.488 64.468c-246.974 0-447.184 200.211-447.184 447.185 0 246.972 200.21 447.185 447.184 447.185s447.185-200.213 447.185-447.185c0-246.974-200.21-447.185-447.185-447.185z m223.795 472.027h-198.95v198.953c0 13.608-11.028 24.64-24.846 24.64-13.72 0-24.845-11.311-24.845-24.64V536.495h-198.95c-13.607 0-24.64-11.027-24.64-24.842 0-13.722 11.31-24.845 24.64-24.845h198.953V287.856c0-13.608 11.027-24.64 24.844-24.64 13.72 0 24.845 11.311 24.845 24.64v198.953h198.95c13.611 0 24.643 11.027 24.643 24.845-0.002 13.719-11.313 24.84-24.644 24.84z"
          p-id="4543"
          fill="#18378A"
        ></path>
      </svg>
    </div>
  )
}

let timer = null
let Index = () => {
  // document.title = '分享/付费'
  document.title = '瑞莱博2024上半年度高标仓市场'
  let navigate = useNavigate()

  let [searchParams, setSearchParams] = useSearchParams();

  // 拼团编号
  const clusterId = searchParams.get('clusterId');
  // 是否成团
  const isCluster = !!clusterId


  // let _userInfo = JSON.parse(sessionStorage.getItem('userInfo') ?? '{}')

  const [userInfo, setUserInfo] = useImmer(JSON.parse(sessionStorage.getItem('userInfo') || '{}'))

  const openId = userInfo?.openId ?? ''

  useEffect(() => {
    if (!openId) {
      wxAuthorize()
    } else {
      if (clusterId) {
        getTeamWorkInfo()
      }
      getSharePayDetail()
    }
    return () => {
      clearInterval(timer);
    }
  }, [clusterId, openId])

  // 微信授权
  let wxAuthorize = async () => {
    const params = qs.parse(window.location.href.split('?')[1])
    if (!params.code) {
      let clusterId = params.clusterId ?? ''
      console.log('clusterId(code不存在的情况)', clusterId)
      let appid = 'wxc005ab723cf1e525'
      let redirect_uri = window.location.origin + `/rlb/YearMiddleReport2024/GroupBuying?clusterId=${clusterId}`
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=&forcePopup=true#wechat_redirect`
      return Promise.reject('跳转了')
    } else {
      // 正常授权成功了
      console.log('code：', params.code)
      // http://localhost:3000/rlb/YearEndReport/0?code=031G2HFa1WCwHG02fpFa1iyLRA1G2HFY&state=o5u_6sl6MooG9dj0xGDC_zqwWExc
      // let shareOpenId = params.state ?? '' // 分享者的openid
      // console.log('shareOpenId', shareOpenId)
      console.log(`code---准备调用/user-empower`)
      let res = await getUserInfoApi({
        code: params.code,
        openId: ''
        // openId: shareOpenId,
      })
      if (res.status === 200) {
        // setUserInfo(res.data)
        if (res.data.openId === '') {
          Toast.show('请授权体验完整服务')
          return
        }
        setUserInfo(res.data)
        sessionStorage.setItem('userInfo', JSON.stringify(res.data))
        wxConfig(res.data.openId)
      }
      return Promise.resolve({
        ...res.data,
      })
    }
  }
  const [clusterDetail, setClusterDetail] = useImmer(null)
  const getTeamWorkInfo = async () => {
    let res = await getTeamWorkInfoApi({ clusterId })
    // res = {
    //   data: {
    //     "clusterId": 1111,
    //     "openId": 1111,
    //     "nickName": 1111,
    //     "headImgUrl": 321,
    //     "validTime": '05:33:01',
    //     "allUserCount": 3,
    //     "teamedUserCount": 1
    //   }
    // }
    if (res.data.clusterId) {
      setClusterDetail(res.data)
      timer = countdown(res.data.validTime, (time) => {
        setClusterDetail(_ => {
          _.validTime = time
        })
      })
    }
  }

  const isOver = clusterDetail?.isOver ?? false

  //获取弹幕
  useEffect(() => {
    getBarrageMessage()
  }, [])

  const [message, setMessage] = useState([])
  const getBarrageMessage = async () => {
    let res = await getBarrageMessageApi()
    setMessage(res.data)
  }

  // let [isSubscribe, setIsSubscribe] = useState(0)
  let [products, setProducts] = useState([])

  let [originalPriceAll, setOriginalPriceAll] = useState(0)
  let [fanPriceAll, setFanPriceAll] = useState(0)


  // useEffect(() => {
  //   // wxConfig()
  // }, [clusterId])

  let getSharePayDetail = async () => {
    let res = await getSharePayDetailApi({
      openId: userInfo.openId,
      year: '2024-H1'
    })
    let unLockProductsRegionIds = res.data.unLockProducts.map(item => item.regionId)
    setProducts(
      yearMiddle2024.map(item => {
        if (unLockProductsRegionIds.includes(item.regionId)) {
          item.originalPrice = 0
          item.fanPrice = 0
        }
        return item
      })
    )
  }

  let onCountChange = (region, count) => {
    setProducts((current) => {
      current.forEach((item) => {
        if (item.regionId === region.regionId) {
          item.count = count
        }
      })

      return clonedeep(current)
    })
  }

  useEffect(() => {
    if (products && products.length > 0) {
      let originalPriceAll = 0
      let fanPriceAll = 0
      products.forEach((item) => {
        if (item.count > 0) {
          originalPriceAll = new Decimal(originalPriceAll).plus(item.originalPrice).toString()
          fanPriceAll = new Decimal(fanPriceAll).plus(item.fanPrice).toString()
        }
      })

      setOriginalPriceAll(originalPriceAll)
      setFanPriceAll(fanPriceAll)
    }
  }, [products])

  let productIds = useMemo(() => {
    let p = []
    products.forEach((item) => {
      if (item.count > 0) {
        p.push(item.regionId)
      }
    })
    return p
  }, [products])

  let payParams = {}

  let isGroup

  let payFn = async (_isGroup) => {
    isGroup = _isGroup
    if (!(productIds && productIds.length > 0)) {
      return Toast.show('还没选择购买的报告~')
    }

    if (!(userInfo && userInfo.email)) {
      return Toast.show('请填写正确的邮箱~')
    }

    let wxJsapiPayParams = {
      'openId': userInfo.openId,
      'productIds': productIds,
      'price': _isGroup ? fanPriceAll : originalPriceAll,
      payType: _isGroup ? 1 : 2,
      teamWorkType: isCluster ? 2 : 1
      // 'price': 0.01,
    }
    if (isCluster) {
      wxJsapiPayParams.clusterId = clusterId
    }
    console.log(wxJsapiPayParams)
    debugger
    let res = await wxJsapiPayApi(wxJsapiPayParams)
    if (res.status === 200) {
      payParams = {
        'appId': res.data.appId,
        'timeStamp': res.data.timeStamp,
        'nonceStr': res.data.nonceStr,
        'package': res.data.packAge,
        'signType': res.data.signType,
        'paySign': res.data.paySign,
      }
      console.log('payParams', payParams)
      wxPay()
    } else {
      Toast.show(res.msg)
    }
  }

  function onBridgeReady() {
    console.log(payParams)
    // eslint-disable-next-line no-undef
    WeixinJSBridge.invoke(
      'getBrandWCPayRequest',
      {
        ...payParams,
      },
      function (res) {
        console.log('getBrandWCPayRequest', res)
        if (res.err_msg === 'get_brand_wcpay_request:ok') {
          console.log(isGroup)
          if (isGroup) {
            navigate('/rlb/YearMiddleReport2024/GroupRecords')
          } else {
            navigate('/rlb/YearEndReport/bought')
          }
        }
      }
    )
  }

  function wxPay() {
    if (typeof WeixinJSBridge == 'undefined') {
      if (document.addEventListener) {
        document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false)
      } else if (document.attachEvent) {
        document.attachEvent('WeixinJSBridgeReady', onBridgeReady)
        document.attachEvent('onWeixinJSBridgeReady', onBridgeReady)
      }
    } else {
      onBridgeReady()
    }
  }
  let [shareVisible, setShareVisible] = useState(false)
  let shareFn = async () => {
    // setShareVisible(true)
    navigate(`/rlb/YearEndReport/share`)
  }

  let goHome = () => {
    navigate(`/rlb/YearMiddleReport2024/1`)
  }

  let goFW = () => {
    window.location.href =
      'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzAwMjc4OTg2Mg==#wechat_redirect'
  }

  // 邮箱
  let [visible, setVisible] = useState(false)
  let send = async (email) => {
    setVisible(false)
    setUserInfo(_ => {
      _.email = email
    })
    // if (!email) {
    //   return
    // }
    // let params = {
    //   openId: userInfo.openId,
    //   email,
    // }
    // if (id === 'lastYear') {
    //   params.type = 1
    // } else {
    //   params.topicId = id
    //   params.type = 0
    // }

    // let res = await updateUserEmailApi(params)
    // Toast.show(res.msg)
    // if (res.status === 200) {
    // }
  }

  const goIntroduce = () => {
    // console.log(1)
    window.location.href = 'https://mp.weixin.qq.com/s/Ayt8Wn818ffpy-Wfc5-n6w'
    //'https://mp.weixin.qq.com/s/BGnzmxXdbhgexOwe-9XENg?token=678050490&lang=zh_CN'
  }

  return (
    <>
      <div className="GroupBuying page">
        <MHead />
        <div className="pageContent">
          <div className="userInfo">
            <Avatar style={{ '--size': '32px' }} src={userInfo.headImgUrl} alt="avatar" />
            <p className="userName">{userInfo.nickName}</p>
            <Button className="activityIntroBtn" color="primary" onClick={() => { goIntroduce() }}>
              <div className='activityIntroBtnTxt' >
                <Image
                  src={ptPng}
                  width={16}
                  height={15}
                  fit="cover"
                  className='image'
                />
                <span>拼团活动流程介绍</span>
              </div>

            </Button>
          </div>
          <div className="tip">
            <Image
              src={sqPng}
              width={17}
              height={13}
              fit="cover"
              className='image'
            />
            <span>不是原价买不起 拼团更有性价比</span>
            <Image
              src={sqPng}
              width={17}
              height={13}
              fit="cover"
              className='image'
            />
          </div>

          <Barrage items={message} />

          {
            clusterDetail && <div className="group">
              <Avatar style={{ '--size': '32px' }} src={clusterDetail.headImgUrl} alt="avatar" />
              <p className="userName">{clusterDetail.nickName}</p>
              <Button className="activityIntroBtn" color="primary">
                团长
              </Button>
              {
                !isOver && <>
                  <p>拼团有效期</p>
                  <p>{clusterDetail.validTime}</p>
                </>
              }
            </div>
          }

          {
            clusterDetail && <div className="groupTip">
              {
                isOver ? <>
                  {/* <div></div> */}
                  <div className='div3'>拼团结束</div>
                </> :
                  <>
                    <div className='div1' style={{ width: `${clusterDetail.teamedUserCount / clusterDetail.allUserCount * 100}%` }}>已有{clusterDetail.teamedUserCount}人组团</div>
                    {
                      clusterDetail.teamedUserCount < 3 && <div className='div2' style={{ width: `${100 - (clusterDetail.teamedUserCount / clusterDetail.allUserCount * 100)}%` }}>待成团，差{clusterDetail.allUserCount - clusterDetail.teamedUserCount}人</div>
                    }
                  </>
              }

            </div>
          }


          <div className='email'>
            <div>
              <MailOutline fontSize={14} />
              <p>邮箱地址</p>
              <p>请输入邮箱地址，用于成团后接收报告</p>
            </div>
            <div>
              <p>{userInfo.email ? userInfo.email : '暂无邮箱'}</p>
              <p onClick={() => { setVisible(true) }}>修改</p>
            </div>
          </div>

          <div className="payList">
            {products.map((item) => {
              return (
                <div className="listItem" key={item.regionId}>
                  <Image
                    className="image"
                    src={item.coverImage}
                    width={105}
                    height={57}
                    fit="cover"
                  />
                  <div className="listItemMiddle">
                    <div className="listTitle">
                      <span>{item.regionName}</span>
                      {
                        item.originalPrice !== 0 && <em>￥{item.originalPrice}</em>
                      }
                    </div>
                    <div className="listTxt">
                      <p>{yearMiddle2024.find(re => re.regionId === item.regionId).sellingpPoint}</p>
                    </div>
                  </div>
                  {
                    item.originalPrice == 0 ?
                      <img src={boughtPng} alt="boughtPng" className='boughtPng' /> :
                      <MStepper
                        disable={item.originalPrice == 0}
                        onChange={(count) => {
                          onCountChange(item, count)
                        }}
                      />
                  }

                </div>
              )
            })}
          </div>

          <div className={`price ${isCluster ? 'isCluster' : ''}`}>
            <div>
              拼团价 ￥ <span>{fanPriceAll}</span>
            </div>
            <div>
              {
                isCluster ?
                  <Image src={jjBlackPng} className='image' fit="fill" width={30} height={28} />
                  :
                  <Image src={jjPng} className='image' fit="fill" width={30} height={28} />
              }
              <div>
                <p>三人拼团</p>
                <p>直降{Decimal(originalPriceAll).minus(Decimal(fanPriceAll)).toString()}元</p>
              </div>
            </div>
          </div>

          <div className="pageFooter">
            <Button className="btn" color="primary" fill="outline" disabled={isOver} onClick={() => { payFn(false) }}>
              {originalPriceAll}元  <span>立即购买</span>
            </Button>
            <Button className="btn" color="primary" disabled={isOver} onClick={() => { payFn(true) }}>
              {fanPriceAll}元   <span>{isCluster ? '立即参团' : '发起拼团'}</span>
            </Button>
          </div>
          <Image src={tipsPng} fit="fill" width="100%" />
        </div>
        {/* <MShare
        visible={shareVisible}
        onClose={() => {
          setShareVisible(false)
        }}
      /> */}
      </div>
      <EMailModal visible={visible} setVisible={setVisible} send={send} />
    </>
  )
}

export default Index
